module.exports = __webpack_public_path__ + "static/img/user_denied.6a4ca0f8.svg";